import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import IntNumberFormatInput from '../../../components/int_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Tooltip, Fade } from '@material-ui/core';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    margin: {
        marginTop: 10,
    },
    rtl: {
        textAlign: 'right',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class EditCvTipoMaquina extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.cvTipoMaquina.id ? this.props.cvTipoMaquina.id : uuidv4(),
            description: this.props.cvTipoMaquina.descr ? this.props.cvTipoMaquina.descr : '',
            cambio: this.props.cvTipoMaquina.cambio ? this.props.cvTipoMaquina.cambio : 0,
            checkedA: this.props.cvTipoMaquina.checkedA ? this.props.cvTipoMaquina.checkedA : false,
            checkedB: this.props.cvTipoMaquina.checkedB ? this.props.cvTipoMaquina.checkedB : false,
            iRecaudacion: this.props.cvTipoMaquina.iRecaudacion ? this.props.cvTipoMaquina.iRecaudacion : 0,
        };

    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    }

    handleBooleanChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'description'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            margin="normal"
                            autoFocus
                            value={this.state.description}
                            onChange={(event) => this.handleValueChange(event, 'description')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <Tooltip title="Indica si es una máquina de cambio" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.cambio ? true : false}
                                        onChange={(event) => this.handleBooleanChange(event, 'cambio')}
                                        value='cambio'
                                    />
                                }
                                label="Cambio"
                            />
                        </Tooltip>
                    </FormControl>
                </div>

                <div className={`${classes.containerPair} ${classes.margin}`}>
                    <FormControl className={classes.formControl}>
                        <Tooltip title="Indica si proporciona regalo" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.checkedA}
                                        onChange={(event) => this.handleBooleanChange(event, 'checkedA')}
                                        value='checkedA'
                                    />
                                }
                                label="Regalo"
                            />
                        </Tooltip>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <Tooltip title="Indica si es máquina de tipo B" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.checkedB}
                                        onChange={(event) => this.handleBooleanChange(event, 'checkedB')}
                                        value='checkedB'
                                    />
                                }
                                label="Tipo B"
                            />
                        </Tooltip>
                    </FormControl>
                </div>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'iRecaudacion'}
                            label={'iRecaudacion'}
                            placeholder={'iRecaudacion'}
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                            margin="normal"
                            value={this.state.iRecaudacion}
                            onChange={(event) => this.handleValueChange(event, 'iRecaudacion')}
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const tipoMaquina = {
                            id: this.state.id,
                            descr: this.state.description,
                            cambio: this.state.cambio ? 1 : 0,
                            regalo: this.state.checkedA,
                            tipoB: this.state.checkedB,
                            iRecaudacion: this.state.iRecaudacion || 0,
                        };

                        if (this.props.checkTipoMaquina(tipoMaquina)) {

                            this.props.okHandler(tipoMaquina);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>
            </div>
        )
    }

}

EditCvTipoMaquina.propTypes = {
    cvTipoMaquina: PropTypes.object.isRequired,
    checkTipoMaquina: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
}


export default withStyles(styles, { withTheme: true })(EditCvTipoMaquina);